<template>


  <div>


    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="用户搜索："  label-for="key">
              <Input search enter-button placeholder="用户手机号" v-model="userForm.phone" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
<!--        <Row type="flex">-->
<!--          <Col>-->
<!--            <Button type="primary"  icon="md-add" @click="add">添加用户</Button>-->
<!--          </Col>-->
<!--        </Row>-->
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >



<!--        <template  slot-scope="{ row, index }" slot="status"> -->
<!--          <Switch v-model="switch1" @on-change="changeSwitch"></Switch>-->
<!--        </template>-->

      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
<!--    <modalSure ref="modalSure" title="轮播图" :confirm="confirm" :id="userid" :modelApi="modelApi" @closeModal="closeModal"></modalSure>-->
  </div>



</template>

<script>

import { record_list} from '@/api/user'
import modalSure from '@/components/modalSure'
import Setting from "@/setting";
export default {
  name: 'index',
  components: { modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        phone: '',
        way: '',
        type: '',
      },
      // modelApi: dels,
      confirm: false,
      isModalVisible: false,
      dataCount: 0,
      field_key: 'nickname',
      userInfo: [],
      arr:{
        user_id:0,
        money:0,
        type:1,
      },
      loading: false,
      userid: 0,
      columns2: [

        {
          title: '用户呢称',
          key: 'user_name',
          align: 'center',
          minWidth: 120
        },


        {
          title: '消费类型',
          key: 'type',
          minWidth: 120
        },
        {
          title: '操作金额',
          key: 'price',
          minWidth: 120
        },
        {
          title: '备注',
          key: 'remarks',
          minWidth: 120
        },
        {
          title: '支付方式',
          key: 'way',
          minWidth: 120
        },
        {
          title: '操作时间',
          key: 'ctime',
          minWidth: 150
        },


      ]
    }
  },
  created () {
    this.bannerList()
  },
  activated () {
    this.bannerList()
  },
  methods: {
    bannerList () {
      this.loading = true
      console.log(this.userForm)
      record_list(this.userForm).then(res => {

        this.userInfo = res.data.list
        this.dataCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.bannerList()
    },
    // 启用禁用用户
    changeSwitch (row) {
      changeUserStatusApi(row.user_id).then(async res => {
        this.$Message.success(res.msg)
        this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 启用禁用用户
    SuperMemberSwitch (row) {
      console.log(row.user_id)
      superMemberStatus(row.user_id).then(async res => {
        this.$Message.success(res.msg)
        this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {

      this.$router.push({ path: '/admin/user/user/edit/' + id })
    },
    add () {
      this.$router.push({ path: '/admin/user/user/edit' })
    },
    del (row) {
      this.userid = row
      // this.confirm = true
      this.$refs.modalSure.isShow = true
    },
    closeModal (val) {
      if (val) {
        this.reload()
      }
    },
    updateStatusModel (modalStatus) {
      this.reload()
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.bannerList()
    },

    showModal(user_id) {
      this.arr.user_id = user_id;
        this.isModalVisible = true;
        this.money=0
        this.type= 1
    },
    handleOk1() {
      let data = this.arr
      setBalance(data).then(res => {
        let msg = '操作成功'
        if (res.code === 200) {
          this.$Message.success(msg)
          this.bannerList()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleCancel() {

    },
  }
}
</script>
